import { css } from 'styled-components'

export const desktopMenuLinkStyles = css`
  display: block;
  margin-bottom: 0.75em;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.grayscale.white};
  text-transform: uppercase;
  &:active {
    color: ${({ theme }) => theme.colors.grayscale.white};
  }
  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.grayscale.white};
    outline-offset: 5px;
  }
`

export const megaMenuLinkStyles = css`
  display: block;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: normal;
  line-height: 1.25;
  text-decoration: none;
  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.brand.white};
    outline-offset: 5px;
  }
  &:hover {
    text-decoration: underline;
  }
`
